import { useRouteParams } from 'labguard-cdk'

/**
 *  Hook providing the userId found in url parameters
 */
export default function useUserId() {
  const { userId } = useRouteParams()
  return userId
}
